<div class="action-plan-details__page" *transloco="let t; read: 'action-plan-details-component'">
  @if (isLoading) {
    <div class="action-plan-details__loader-wrapper xi-loader-container__center">
      <xi-animation [loop]="true" animation="cx_loader"></xi-animation>
    </div>
  }
  @if (!isLoading) {
    <div class="action-plan-details__container">
      <div class="action-plan-details__header">
        <a [routerLink]="[backButtonUrl]" class="action-plan-details__back">
          <xi-icon icon="arrow_left" color="CX"></xi-icon
          ><span class="action-plan-details__back-text">{{ backButtonText }}</span>
        </a>
        <div class="action-plan-details__title">
          <span class="action-plan-details__title-text">{{ title }}</span>
          <app-status-label
            [status]="actionPlan.status"
            [isFixed]="isReadOnly"
            (statusChange)="onStatusChanged($event)"
          ></app-status-label>
        </div>
        <div class="action-plan-details__actions">
          <xi-icon-button
            icon="settings"
            color="CX"
            buttonSize="large"
            [disabled]="isDashboardDeleted"
            [matTooltip]="t('dashboard-deleted')"
            [matTooltipDisabled]="!isDashboardDeleted"
            (onClick)="onOpenSettingsDrawer()"
          >
          </xi-icon-button>
          <xi-icon-button icon="kabob" color="CX" buttonSize="large" [disabled]="true">
          </xi-icon-button>
        </div>
      </div>
      <div class="action-plan-details__scrollbar">
        <div class="action-plan-details__details-container">
          <span class="action-plan-details__details-title">{{ t('action-plan-details') }}</span>
          <div class="action-plan-details__details-grid-container">
            <div class="action-plan-details__details-info-container">
              <div class="action-plan-details__details-column">
                <span class="action-plan-details__details-column-title">{{ t('due-date') }}</span>
                <span class="action-plan-details__details-label">{{ t('expires') }}</span>
                <span class="action-plan-details__details-label">{{ t('created') }}</span>
              </div>
              <div class="action-plan-details__details-column">
                <div class="action-plan-details__details-title-cell">
                  <div
                    class="action-plan-details__due-date-status"
                    [ngClass]="isExpired ? 'expired' : 'left'"
                  >
                    {{ dueDateStatusText | uppercase }}
                  </div>
                </div>
                <div class="action-plan-details__due-date-container">
                  <span class="action-plan-details__details-value">{{
                    actionPlan.due_date | date: 'dd-MM-yyyy'
                  }}</span>
                  <a class="action-plan-details__details-link" (click)="onOpenSettingsDrawer()">{{
                    t('extend-due-date')
                  }}</a>
                </div>
                <span class="action-plan-details__details-value">{{
                  actionPlan.creation_date | date: 'dd-MM-yyyy'
                }}</span>
              </div>
            </div>
            <div class="action-plan-details__details-info-container">
              <div class="action-plan-details__details-column">
                <span class="action-plan-details__details-column-title">{{ t('details') }}</span>
                <span class="action-plan-details__details-label">{{ t('project') }}</span>
                <span class="action-plan-details__details-label">{{ t('data-collection') }}</span>
                <span class="action-plan-details__details-label">{{ t('created-by') }}</span>
                <span class="action-plan-details__details-label">{{ t('related-dashboard') }}</span>
              </div>
              <div class="action-plan-details__details-column">
                <span class="action-plan-details__details-title-cell"></span>
                <a [routerLink]="[projectUrl]" class="action-plan-details__details-link">{{
                  actionPlan.metadata.projectName
                }}</a>
                <span class="action-plan-details__details-value">{{
                  actionPlan.metadata.collectionDisplayName
                }}</span>
                <span class="action-plan-details__details-value">{{
                  actionPlan.creator_user_name
                }}</span>
                <a
                  [routerLink]="[dashboardUrl]"
                  [disabled]="isDashboardDeleted"
                  class="action-plan-details__details-link"
                  [ngClass]="{ 'action-plan-details__details-link--disabled': isDashboardDeleted }"
                  >{{ !isDashboardDeleted ? dashboard.title : t('dashboard-deleted') }}</a
                >
              </div>
            </div>
          </div>
          @if (actionPlan.notes) {
            <xi-accordion>
              <div slot="children">
                <xi-accordion-item [id]="0" title="{{ t('description') }}" [open]="true">
                  <div slot="children">
                    {{ actionPlan.notes }}
                  </div>
                </xi-accordion-item>
              </div>
            </xi-accordion>
          }
        </div>
        <!-- hide temporarily due to DASH-7014 -->
        @if (false) {
          <div class="action-plan-details__tab-bar-wrapper">
            <xi-horizontal-tab-bar
              [data]="tabs"
              [(activeTabId)]="activeTabId"
              [hasTransparentBackground]="true"
              color="orca"
            >
            </xi-horizontal-tab-bar>
          </div>
          <div class="action-plan-details__tab-container">
            @switch (activeTabId) {
              @case (progressTabId) {
                <app-action-plan-details-progress-tab
                  [actionPlan]="actionPlan"
                ></app-action-plan-details-progress-tab>
              }
              @case (itemsTabId) {
                <app-action-plan-details-items-tab
                  [actionPlan]="actionPlan"
                  [(options)]="itemsTabOptions"
                  (countChange)="onChildCountChange()"
                ></app-action-plan-details-items-tab>
              }
              @case (tasksTabId) {
                <app-action-plan-details-tasks-tab
                  [actionPlan]="actionPlan"
                  [(options)]="tasksTabOptions"
                  (countChange)="onChildCountChange()"
                  (navigateToItem)="onNavigateToItem($event)"
                ></app-action-plan-details-tasks-tab>
              }
            }
          </div>
        }
      </div>
    </div>
  }
</div>

@if (isSettingsDrawerOpen) {
  <app-action-plan-settings-drawer
    [open]="isSettingsDrawerOpen"
    [actionPlan]="actionPlan"
    [groupId]="groupId"
    [dashboard]="dashboard"
    (close)="onCloseSettingsDrawer($event)"
  >
  </app-action-plan-settings-drawer>
}
